import Dropzone, { Accept } from "react-dropzone";
import { useTranslation } from "react-i18next";
import FileIcon from "@/assets/icons/file.svg?react";
import TrashIcon from "@/assets/icons/trash.svg?react";

type DropzoneStyledProps = {
  files: any | null;
  setFiles: React.Dispatch<React.SetStateAction<any | null>>;
  handleFileChange: (files: any) => void;
  handleRemoveFile: (index: number) => void;
  dropZoneText?: string;
  dropZoneSubText?: string;
  accept?: Accept;
  error?: boolean;
  isDesactivated?: boolean;
  maxFiles?: number;
};

export const DropzoneStyled = ({
  files,
  handleFileChange,
  handleRemoveFile,
  dropZoneText,
  dropZoneSubText,
  accept,
  error,
  isDesactivated = false,
  maxFiles,
}: DropzoneStyledProps) => {
  const { t } = useTranslation("shared");
  return (
    <div className="flex w-full flex-col gap-4">
      {files &&
        files.length > 0 &&
        files.map((file: any, index: number) => (
          <div
            key={index}
            className="flex w-full flex-row items-center justify-between gap-4 rounded-lg border bg-gray-50 p-4"
          >
            <div className="rounded-full border p-2">
              <FileIcon />
            </div>
            <div className="flex w-full flex-col justify-start gap-2 overflow-hidden">
              <p className="truncate text-sm font-medium text-gray-700">{file.name}</p>
              <p className="text-xs font-medium text-gray-600">
                {t("dropzone.fileSize", { size: Math.floor(file.size / 1000) })}
              </p>
            </div>
            <button
              className="focus:outline-hidden"
              onClick={() => handleRemoveFile(index)}
              type="button"
            >
              <TrashIcon className="text-gray-600" />
            </button>
          </div>
        ))}
      {isDesactivated || (maxFiles && files && files.length >= maxFiles) ? (
        <></>
      ) : (
        <Dropzone
          onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}
          accept={accept || { "application/pdf": [".pdf"] }}
          maxFiles={maxFiles}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div
                {...getRootProps()}
                className={`${error ? "border-red-500" : "border-brand700"} bg-brand50 flex w-full items-center justify-center rounded-lg border-2 border-dashed p-4 hover:cursor-pointer`}
              >
                <input {...getInputProps()} />
                <div>
                  <span className="text-brand700 hover:text-brand600 truncate text-center text-sm font-medium text-wrap">
                    {dropZoneText ?? t("dropzone.text")}
                  </span>
                </div>
              </div>
            </section>
          )}
        </Dropzone>
      )}
      {dropZoneSubText && (
        <span className="w-full truncate text-center text-xs font-medium text-gray-600">
          {dropZoneSubText}
        </span>
      )}
    </div>
  );
};
